export default {
  title: 'Resultado de la emisión de facturas',
  documentValidation: 'Validación de documento:',
  syntacticValidation: 'Validación sintáctica:',
  semanticValidation: 'Validación semántica:',
  summary: 'Resumen',
  correctBills: 'Facturas correctas',
  rejectedBills: 'Facturas rechazadas',
  totalBills: 'Total de Facturas'
}
